import React, { useState } from 'react';

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
} from 'recharts';

import { formatDate } from 'helpers/date';

const tooltipWrapperStyles = {
  backgroundColor: 'rgba(0,0,0,.85)',
  fontsize: '14px',
  color: '#fff',
  borderRadius: '4px',
};

const UnloadingCpmChart = ({ stats, syncId, tzOffset, ...rest }) => {
  const [visibility, setVisibility] = useState({
    last5MinsCpmFormatted: true,
    avgCpmFormatted: true,
    manMinLast5MinsFormatted: true,
    tot_carts: false,
    tot_clamps: false,
    tot_labor_man_mins: false,
  });

  let cpmMin = 0, cpmMax = 0;
  let totalMin = 0, totalMax = 0;
  const data = stats.map(stat => {
    stat = { ...stat };
    stat.last5MinsCpmFormatted = Number(stat.last_5min_rate_cpm).toFixed(3);
    stat.avgCpmFormatted = Number(stat.avg_cpm || 0).toFixed(3);
    stat.manMinLast5MinsFormatted = Number(stat.man_min_rate_last5_mins).toFixed(3);

    cpmMin = Math.min(
      cpmMin,
      stat.last5MinsCpmFormatted,
      stat.avgCpmFormatted,
      stat.manMinLast5MinsFormatted
    );
    cpmMax = Math.max(
      cpmMax,
      stat.last5MinsCpmFormatted,
      stat.avgCpmFormatted,
      stat.manMinLast5MinsFormatted
    );
    totalMin = Math.min(
      totalMin,
      stat.tot_carts,
      stat.tot_clamps,
      stat.tot_labor_man_mins,
    );
    totalMax = Math.max(
      totalMax,
      stat.tot_carts,
      stat.tot_clamps,
      stat.tot_labor_man_mins,
    );
    return stat;
  });

  cpmMax = Math.ceil(cpmMax);
  totalMax = Math.ceil(totalMax);

  return (
    <ResponsiveContainer width="100%" height={350} {...rest}>
      <LineChart data={data} syncId={syncId}>
        <CartesianGrid strokeDasharray="3 3" stoke="#E7F3F8" />
        <XAxis dataKey="dt_datetime" minTickGap={15} tickMargin={10} stroke="#2F454E" tickFormatter={value => {
          return formatDate(Date.parse(value), 'HH:mm', {
            tzOffset
          });
        }} />
        <YAxis yAxisId="cpm" stroke="#2F454E" strokeWidth="1" domain={[cpmMin, cpmMax]}>
          <Label value="CPM" position="insideLeft" angle={-90} offset={10} />
        </YAxis>
        <YAxis yAxisId="total" stroke="#2F454E" strokeWidth="1" orientation="right" domain={[totalMin, totalMax]}>
          {/* <Label value="Total Mins" angle={90} position="insideCenter" offset={-5} /> */}
        </YAxis>

        <Tooltip contentStyle={tooltipWrapperStyles}
          labelFormatter={label => formatDate(Date.parse(label), 'yy-MM-dd HH:mm', {
            tzOffset
          })}
        />
        <Legend verticalAlign="top" height={36} onClick={({ dataKey}) => {
          setVisibility({ ...visibility, [dataKey]: !visibility[dataKey] });
        }} />

        <Line yAxisId="cpm" name="Last 5 Min CPM" type="monotone" hide={!visibility.last5MinsCpmFormatted} dataKey="last5MinsCpmFormatted" dot={false} activeDot={true} stroke="#FADB14" strokeWidth="2" />
        <Line yAxisId="cpm" name="Average CPM" type="monotone" hide={!visibility.avgCpmFormatted} dataKey="avgCpmFormatted" dot={false} activeDot={true} stroke="#F5222D" strokeWidth="2" />
        <Line yAxisId="cpm" name="Last 5 Min Man Mins" type="monotone" hide={!visibility.manMinLast5MinsFormatted} dataKey="manMinLast5MinsFormatted" dot={false} activeDot={true} stroke="#13C2C2" strokeWidth="2" />
        <Line yAxisId="total" name="Total Carts" type="monotone" hide={!visibility.tot_carts} dataKey="tot_carts" dot={false} activeDot={true} stroke="#A0D911" strokeWidth="2" />
        <Line yAxisId="total" name="Total Clamps" type="monotone" hide={!visibility.tot_clamps} dataKey="tot_clamps" dot={false} activeDot={true} stroke="#5B8C00" strokeWidth="2" />
        <Line yAxisId="total" name="Total Man Mins" type="monotone" hide={!visibility.tot_labor_man_mins} dataKey="tot_labor_man_mins" dot={false} activeDot={true} stroke="#85A5FF" strokeWidth="2" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default UnloadingCpmChart;
